import { IHeaderParams } from 'ag-grid-community';
import { useDataSyncText } from 'src/components/star-grid/hooks/useDataSyncText';
import React from 'react';
import { displayReportPeriod } from 'src/components/star-grid/utils/pnlStatementGrid';

export const ReportPeriodHeader: React.FC<IHeaderParams & { readonly periodType?: string }> = ({ displayName, periodType }) => {
  const text = useDataSyncText();
  const periodLabels: Record<string, string> = {
    actual: text('actualPeriodLabel'),
    forecast: text('forecastPeriodLabel'),
    variance: text('variancePeriodLabel'),
    varianceExFx: text('varianceExFxPeriodLabel')
  };
  const periodLabel = periodType ? periodLabels[periodType] ?? periodType : undefined;
  return (
    <div className={`sg-report-period${periodType !== undefined ? ' sg-report-period-with-type' : ''}`} title={displayName}>
      <span>{displayReportPeriod(displayName)}</span>
      {periodType !== undefined && <span className="sg-report-period-type">{periodLabel}</span>}
    </div>
  );
};

export const ReportHierarchyHeader: React.FC<IHeaderParams> = ({ displayName }) => (
  <div className="sg-report-hierarchy-title" title={displayName}>
    {displayName}
  </div>
);
